import { Fragment, useState, useEffect } from 'react';
import { Transition } from '@headlessui/react';
import { FaEllipsisV, FaTimes } from 'react-icons/fa';
import { Menu, MenuItem } from '@mui/material';
import axios from '../../../services/api';
import { toast } from 'react-toastify';
import CreateBuildingModal from './CreateBuildingModal';
import RoomModal from './RoomModal';
import editIcon from '../../../styles/edit_icon.png';
import moment from 'moment';
import ConfirmModal from '../../../components/modals/ConfirmModal';
import { useTranslation } from 'react-i18next';

export default function BuildingModal({ isOpen, onClose, community, onSuccess }) {
  const { t } = useTranslation();
  const [buildings, setBuildings] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedBuilding, setSelectedBuilding] = useState(null);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isRoomModalOpen, setIsRoomModalOpen] = useState(false);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);

  const handleMenuClick = (event, building) => {
    setAnchorEl(event.currentTarget);
    setSelectedBuilding(building);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const fetchBuildings = async () => {
    try {
      const response = await axios.get(`/buildings/${community._id}`);
      setBuildings(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleDelete = async (building) => {
    try {
      await axios.delete(`/buildings/${building._id}`);
      toast.success(t('Delete Successfully'));
      fetchBuildings();
      onSuccess();
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (isOpen && community) {
      fetchBuildings();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, community]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <div className="fixed inset-0 bg-black/50 flex items-center justify-end pr-[5%] pt-6 z-50 app-text">
        <div className="bg-white w-[70vw] h-[85vh] rounded-lg shadow-xl">
          <div className="bg-black text-white px-4 py-3 rounded-t-lg flex justify-between items-center">
            <h2 className="text-lg font-semibold">
              {t('Building')}
            </h2>
            <button
              onClick={onClose}
              className="text-white/70 hover:text-white transition-colors"
            >
              <FaTimes />
            </button>
          </div>

          <div className="px-4 pt-2 py-4 h-[calc(85vh-60px)] overflow-hidden">
            <div className="flex justify-between items-center h-title mb-2">
              <h3 className="text-lg font-medium">
                {t('Community Name')}: {community?.communityName}
              </h3>
              <button
                onClick={() => {setSelectedBuilding(null); setIsCreateModalOpen(true);}}
                className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
              >
                {t('Add New')}
              </button>
            </div>

            <div className={`${buildings.length > 0 ? 'overflow-auto' : 'overflow-hidden'} relative h-table-height-title-1`}>
              <table className="w-full">
                <thead className="sticky top-0 z-30 bg-skin-primary shadow-sm">
                <tr className="border-b border-skin-base/10">
                    <th className="sticky left-0 z-10 bg-white px-4 py-2 text-left font-semibold text-skin-base min-w-[60px]">
                      {t('No.')}
                    </th>
                    <th className="px-4 py-2 text-left font-semibold text-skin-base min-w-[150px]">
                      {t('Building Name')}
                    </th>
                    {/* <th className="px-4 py-2 text-left font-semibold text-skin-base min-w-[100px]">
                      Floors
                    </th> */}
                    <th className="px-4 py-2 text-left font-semibold text-skin-base min-w-[100px]">
                      {t('Rooms')}
                    </th>
                    <th className="px-4 py-2 text-left font-semibold text-skin-base min-w-[150px]">
                      {t('Lock ID')}
                    </th>
                    <th className="px-4 py-2 text-left font-semibold text-skin-base min-w-[120px]">
                      {t('Start Time')}
                    </th>
                    <th className="px-4 py-2 text-left font-semibold text-skin-base min-w-[120px]">
                      {t('End Time')}
                    </th>
                    <th className="sticky right-0 z-10 bg-white px-4 py-2 text-left font-semibold text-skin-base min-w-[100px] text-right">
                      {t('Actions')}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {buildings.map((building, index) => (
                    <tr key={building._id} className="hover:bg-gray-50">
                      <td className="sticky left-0 z-10 bg-white px-4 py-2 whitespace-nowrap border-b border-gray-200 group-hover:bg-gray-50">
                        {index + 1}
                      </td>
                      <td className="px-4 py-2 whitespace-nowrap border-b border-gray-200">
                        {building.buildingName}
                      </td>
                      {/* <td className="px-4 py-2 whitespace-nowrap border-b border-gray-200">
                        {building.floors}
                      </td> */}
                      <td className="px-4 py-2 whitespace-nowrap border-b border-gray-200">
                        {building.rooms?.length}
                      </td>
                      <td className="px-4 py-2 whitespace-nowrap border-b border-gray-200">
                        {building.lockId}
                      </td>
                      <td className="px-4 py-2 whitespace-nowrap border-b border-gray-200">
                        {community?.startTime?moment(community.startTime).format('YYYY-MM-DD'):''}
                      </td>
                      <td className="px-4 py-2 whitespace-nowrap border-b border-gray-200">
                        {community?.endTime?moment(community.endTime).format('YYYY-MM-DD'):''}
                      </td>
                      <td className="sticky right-0 z-10 bg-white px-4 py-2 whitespace-nowrap border-b border-gray-200 group-hover:bg-gray-50">
                        <div className="flex items-center gap-2 justify-end">
                          <button
                            onClick={() => {
                              setSelectedBuilding(building);
                              setIsCreateModalOpen(true);
                            }}
                            className="text-gray-600 hover:text-gray-900"
                          >
                            <img src={editIcon} alt="edit" className="w-4 h-4" />
                          </button>
                          <button
                            onClick={(e) => handleMenuClick(e, building)}
                            className="text-gray-600 hover:text-gray-900"
                          >
                            <FaEllipsisV />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        className="mt-2"
        PaperProps={{
          className: 'bg-[#1c1f3b] border-2 border-[#393e591f] rounded-lg shadow-xl',
          elevation: 0
        }}
      >
        {/* <MenuItem
          onClick={() => {
            handleDetailClick(selectedBuilding);
            handleClose();
          }}
          className="text-white hover:bg-[#292f4c]"
        >
          Details
        </MenuItem> */}
        <MenuItem
          onClick={() => {
            setIsRoomModalOpen(true);
            handleClose();
          }}
          className="text-white hover:bg-[#292f4c]"
        >
          {t('Rooms')}
        </MenuItem>
        <MenuItem
          onClick={() => {
            setIsConfirmOpen(true);
            handleClose();
          }}
          className="text-white hover:bg-[#292f4c]"
        >
          {t('Delete')}
        </MenuItem>
      </Menu>

      <CreateBuildingModal
        isOpen={isCreateModalOpen}
        onClose={() => setIsCreateModalOpen(false)}
        onSuccess={() => {
          fetchBuildings();
          onSuccess();
        }}
        building={selectedBuilding}
        community={community}
      />

      <RoomModal
        isOpen={isRoomModalOpen}
        onClose={() => setIsRoomModalOpen(false)}
        building={selectedBuilding}
        onSuccess={() => {
          fetchBuildings();
          onSuccess();
        }}
      />

      <ConfirmModal
        isOpen={isConfirmOpen}
        onClose={() => setIsConfirmOpen(false)}
        onConfirm={() => handleDelete(selectedBuilding)}
        title={t('Delete Building')}
        message={t('Are you sure you want to delete this building? This action cannot be undone.')}
        confirmText={t('Delete')}
        cancelText={t('Cancel')}
        type="danger"
      />
    </Transition>
  );
}
